"use strict";
exports.__esModule = true;
exports.isInRange = void 0;
var isInRange = function (value, min, max) { return value >= min && value <= max; };
exports.isInRange = isInRange;
